<template>
  <div class="product-tag" :class="tagClasses">
    {{ $t(message) }}
  </div>
</template>

<script>
export default {
  name: 'ProductTag',
  props: {
    isProductAvailable: {
      type: Boolean,
      default: true
    },
    isProductInStock: {
      type: Boolean,
      default: true
    },
    isProductRecommended: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      required: true
    }
  },
  computed: {
    tagClasses() {
      return {
        'product-tag--out-of-stock': !this.isProductInStock && this.isProductAvailable,
        'product-tag--coming-soon': !this.isProductAvailable,
        'product-tag--recommended': this.isProductRecommended
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.product-tag {
  padding: 4px 8px;
  font-family: var(--u-font-family-Helvetica);
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.4px;

  text-align: center;
  border-radius: 3px;
  color: var(--u-color-grey-900);
  background-color: var(--u-color-grey-100);

  &--out-of-stock {
    color: var(--u-color-red-300);
    background-color: var(--u-color-red-100);
  }

  &--coming-soon {
    color: var(--u-color-orange--500);
    background-color: var(--u-color-orange-100);
  }

  &--recommended {
    color: var(--u-color-white);
    background-color: var(--u-color-grey-900);
  }
}

@media (min-width: 960px) {
  .product-tag {
    padding: 6px 12px;
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
